import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export function ButtonGroup({ options, selectedOption, onChange }) {
  return (
    <div className="w-full flex flex-wrap gap-3">
      {options.map((option) => (
        <button
          className={`border border-slate-400 px-4 py-2 hover:bg-primary hover:text-white transition duration-200 rounded-md uppercase ${
            selectedOption === option ? "bg-primary text-white" : ""
          }`}
          onClick={() => {
            onChange(option);
          }}
          type="button"
          key={option}
        >
          {option}
        </button>
      ))}
    </div>
  );
}

export function InputField({
  label,
  type,
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <div className="w-full mb-5 md:w-[48%]">
      <label
        htmlFor={label}
        className={`block mb-2 ${
          required ? "after:content-['*'] after:text-pink-500 after:ml-0.5" : ""
        }`}
      >
        {label}
      </label>
      <input
        type={type}
        required={required}
        id={label}
        onChange={onChange}
        value={value ? value : ""}
        disabled={disabled}
        placeholder={label}
        className={`border border-slate-400 rounded-md px-4 py-3 w-full focus:outline-none ${
          required
            ? "invalid:text-pink-600 invalid:focus:border-pink-600 invalid:focus:ring-pink-600 peer"
            : ""
        }`}
      />
      <p
        className={`text-sm m-1 text-pink-600 invisible peer-invalid:visible ${
          required ? "block" : "hidden"
        }`}
      >
        Required
      </p>
    </div>
  );
}

export function SelectionField({ label, value, onChange, menus }) {
  return (
    <div className="w-full mb-5 md:w-[48%]">
      <label htmlFor="" className="block mb-2">
        {label}
      </label>
      <Select
        value={value}
        inputProps={{
          name: "filter",
          id: "uncontrolled-native",
        }}
        className="w-full"
        onChange={(e) => onChange(e.target.value)}
      >
        {menus &&
          menus.map((menu) => (
            <MenuItem value={menu} key={menu}>
              <span className="capitalize">{menu}</span>
            </MenuItem>
          ))}
      </Select>
    </div>
  );
}

export function BatasBatasTanah({
  label,
  depan,
  kiri,
  kanan,
  belakang,
  setDepan,
  setKiri,
  setKanan,
  setBelakang,
}) {
  return (
    <div className="w-full mb-5 md:w-[48%]">
      <label
        htmlFor=""
        className="block mb-2 after:content-['*'] after:text-pink-500 after:ml-0"
      >
        {label}
      </label>
      <input
        type="text"
        className="border border-slate-400 block mb-2 rounded-md px-4 py-3 w-full"
        placeholder="Depan"
        value={depan}
        required
        onChange={(e) => setDepan(e.target.value)}
      />
      <input
        type="text"
        className="border border-slate-400 block mb-2 rounded-md px-4 py-3 w-full"
        value={kiri}
        required
        placeholder="Kiri"
        onChange={(e) => setKiri(e.target.value)}
      />
      <input
        type="text"
        className="border border-slate-400 block mb-2 rounded-md px-4 py-3 w-full"
        value={kanan}
        required
        placeholder="Kanan"
        onChange={(e) => setKanan(e.target.value)}
      />
      <input
        type="text"
        className="border border-slate-400 block mb-2 rounded-md px-4 py-3 w-full"
        value={belakang}
        placeholder="Belakang"
        onChange={(e) => setBelakang(e.target.value)}
      />
    </div>
  );
}

export function Deskripsi({ label, value, onChange }) {
  return (
    <div className="w-full mb-5 md:w-[48%]">
      <label htmlFor="decs" className="block mb-2">
        {label}
      </label>
      <textarea
        name={label}
        value={value}
        required
        id="desc"
        className="border border-slate-400 p-3 text-sm rounded-md w-full h-52"
        onChange={(e) => {
          onChange(e.target.value);
        }}
      ></textarea>
    </div>
  );
}

export function Action({ label, handleClick }) {
  return (
    <div className="flex gap-5">
      <Link
        to={"/"}
        className="hover:bg-primary flex items-center hover:text-white transiiton duration-200 border px-8 py-3 rounded-md border-black"
      >
        Cancel
      </Link>
      <button
        className="px-8 py-3 flex items-center rounded-md text-white bg-primary hover:opacity-80 transition duration-200"
        type="submit"
        onClick={handleClick}
      >
        {label}
      </button>
    </div>
  );
}

export const InputFile = ({ file, onChange, index }) => {
  const [dataFile, setDataFile] = useState(null);

  const urlToFile = async (url, filename) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], filename, { type: blob.type });

    return file;
  };

  const getFile = async () => {
    const splitPublic = file.public_id.split("/");
    const filename = `${splitPublic[splitPublic.length - 1]}.${file.format}`;

    const fetchedFile = await urlToFile(file.secure_url, filename);
    console.log(fetchedFile);
    setDataFile(fetchedFile);
  };

  useEffect(() => {
    getFile();
  }, [file]);

  return (
    <>
      {dataFile && (
        <input
          type="file"
          value={dataFile.name}
          accept=".jpg, .png, .jpeg"
          className="border border-slate-400 rounded-md mb-2 px-4 py-[9px] w-full"
          onChange={(e) => {
            onChange(e.target.files, index);
          }}
        />
      )}
    </>
  );
};
